import api from '../apis/api'
import { tokenConfig } from '../config'

export const GenerateIdeaAPI = (body, state) => {
  return new Promise((res, rej) => {
    api.post(`/content-generator`, body, tokenConfig(state))
      .then(resp => res(resp))
      .catch(err => rej(err?.response?.data?.error?.message || 'Error, Please try again later'))
  })
}